'use client';
import { FooterIcon } from '@practium/ui';
import styles from './AuthPromoPanel.module.css';
import { ReactNode } from 'react';
import { AuthPromoCard } from '../Cards/AuthPromoCard';

interface StatsCardProps {
	icon: ReactNode;
	label: string;
	value: string;
}

interface AuthPromoPanelProps {
	promoImageSrc: string;
	promoTitle: string;
	promoDescription: string;
	statsCard: StatsCardProps;
	sectionHeading: string;
	sectionText: string;
}

export const AuthPromoPanel = ({
	promoImageSrc,
	promoTitle,
	promoDescription,
	statsCard,
	sectionHeading,
	sectionText,
}: AuthPromoPanelProps) => {
	return (
		<div className={styles.panel}>
			<div className={styles.ellipse} />

			<div className={styles.copyrightSection}>
				<p className={styles.copyright}>© 2022 Soil. Todos os Direitos Reservados</p>
			</div>

			<div className={styles.mainContent}>
				<div className={styles.cardSection}>
					<AuthPromoCard
						imageSrc={promoImageSrc}
						title={promoTitle}
						description={promoDescription}
						statsCard={statsCard}
					/>
				</div>

				<div className={styles.textSection}>
					<h2 className={styles.heading}>{sectionHeading}</h2>
					<p className={styles.text}>{sectionText}</p>
				</div>
			</div>

			<div className={styles.footerIcon}>
				<FooterIcon />
			</div>
		</div>
	);
};
